import { render, staticRenderFns } from "./article-prices.vue?vue&type=template&id=f4592264&scoped=true&"
import script from "./article-prices.ts?vue&type=script&lang=ts&"
export * from "./article-prices.ts?vue&type=script&lang=ts&"
import style0 from "./article-prices.scss?vue&type=style&index=0&id=f4592264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4592264",
  null
  
)

export default component.exports